import { lazy } from "react";
import CustomeFields from "../components/CustomeFields";
import ResetPassForm from "../components/Auth/ResetPassForm";
import BankTransaction from "../components/LawyerCompo/Accounts/BankTransaction";
import CaseDashboard from "../pages/LawyerPages/Cases/CaseDashboard";
import CaseTemplate from "../components/LawyerCompo/Settings/AllTemplatePage&Compnent/CaseTemplate";
import NoRoleAssignedPage from "../components/Auth/NoRoleAssignedPage";

import FolderView from "../components/LawyerCompo/Document/FolderView";
import PaymentStatusPage from "../RazorpayUtils/PaymentStatusPage";
import TermsAndConditions from "../pages/LandingPages/TermsAndConditions";
import PrivacyPolicy from "../pages/LandingPages/PrivacyPolicy";
import SidebarAICard from "../components/LawyerCompo/Dashboard/SidebarAICard";
import AIEmployeePage from "../components/LawyerCompo/Dashboard/AIEmployeePage";
import AiTeamPage from "../pages/LandingPages/AiTeamPage";
import AIWorkspace from "../components/AiBotUtils/AIWorkspace";
import TrialCheckout from "../pages/LandingPages/TrialCheckout";
import FoundingOfferPage from "../pages/LandingPages/FoundingOfferPage";
import TrialStatusPage from "../pages/LandingPages/TrialStatusPage";
import StartTrialPage from "../pages/StartTrialPage";
import TrialSuccessPopUp from "../pages/TrialSuccessPopUp";

// Lazy imports
const ProfilePage = lazy(() => import("../pages/LawyerPages/ProfilePage"));
const SignupPage = lazy(() => import("../pages/SignupPage"));
const HomePage = lazy(() => import("../pages/LandingPages/HomePage"));
const PricingPage = lazy(() => import("../pages/LandingPages/PricingPage"));
const AboutPage = lazy(() => import("../pages/LandingPages/AboutPage"));
const NewUserPage = lazy(
  () => import("../pages/LawyerPages/TeamMembers/NewUserPage"),
);
const DashboardPage = lazy(() => import("../pages/LawyerPages/DashboardPage"));
const ContactPage = lazy(
  () => import("../pages/LawyerPages/Contact/ContactPage"),
);
const ContactDashboard = lazy(
  () => import("../pages/LawyerPages/Contact/ContactDashboard"),
);
const TaskPage = lazy(() => import("../pages/LawyerPages/Task/TaskPage"));
const TaskTemplatePage = lazy(
  () => import("../pages/LawyerPages/Task/TaskTemplatePage"),
);
const GroupTaskTempPage = lazy(
  () => import("../pages/LawyerPages/Task/GroupTaskTempPage"),
);
const TaskListDetailsPage = lazy(
  () => import("../pages/LawyerPages/Task/TaskListDetailsPage"),
);
const TaskTypePage = lazy(
  () => import("../pages/LawyerPages/Task/TaskTypePage"),
);
const CasesPage = lazy(() => import("../pages/LawyerPages/Cases/CasesPage"));
const CalendarPage = lazy(
  () => import("../pages/LawyerPages/Calendar/CalendarPage"),
);
const ActivitiesPage = lazy(
  () => import("../pages/LawyerPages/Activities/ActivitiesPage"),
);
const BillingPage = lazy(
  () => import("../pages/LawyerPages/Billing/BillingPage"),
);
const AccountPage = lazy(
  () => import("../pages/LawyerPages/Accounts/AccountPage"),
);
const DocumentPage = lazy(
  () => import("../pages/LawyerPages/Documents/DocumentPage"),
);
const DocumentTemplatePage = lazy(
  () => import("../pages/LawyerPages/Documents/DocumentTemplatePage"),
);
const DocumentCategory = lazy(
  () => import("../pages/LawyerPages/Documents/DocumentCategory"),
);
const Communications = lazy(
  () => import("../pages/LawyerPages/Communications/CommunicationPage"),
);
const ReportPage = lazy(
  () => import("../pages/LawyerPages/Reports/ReportPage"),
);
const SettingPage = lazy(
  () => import("../pages/LawyerPages/Settings/SettingPage"),
);

export const routes = [
  // Landing pages
  {
    path: "/",
    element: <HomePage />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditions />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/pricing/success",
    element: <PaymentStatusPage />,
    isProtected: false,
    redirectIfAuthenticated: false,
    isLanding: false,
  },
  {
    path: "/pricing/failure",
    element: <PaymentStatusPage />,
    isProtected: false,
    redirectIfAuthenticated: false,
    isLanding: false,
  },
  {
    path: "/about-us",
    element: <AboutPage />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/ai-team",
    element: <AiTeamPage />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/ai_team",
    element: <AiTeamPage />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/founding-50",
    element: <FoundingOfferPage />,
    isProtected: false,
    isLanding: true,
    redirectIfAuthenticated: false,
  },
  {
    path: "/checkout-50",
    element: <TrialCheckout />,
    isProtected: false,
    isLanding: false,
    redirectIfAuthenticated: false,
  },
  {
    path: "/checkout-50/status",
    element: <TrialStatusPage />,
    isProtected: false,
    isLanding: false,
    redirectIfAuthenticated: false,
  },

  // Auth pages (not landing)
  {
    path: "/login",
    element: <SignupPage />,
    isProtected: false,
    isLanding: false,
  },
  {
    path: "/start-trial",
    element: <StartTrialPage />,
    isProtected: false,
    isLanding: false,
  },
  {
    path: "/trial-success/:email",
    element: <TrialSuccessPopUp />,
    isProtected: false,
    isLanding: false,
  },
  {
    path: "/request-forgot-password/",
    element: <ResetPassForm />,
    isProtected: false,
    isLanding: false,
  },
  {
    path: "/request-forgot-password/verification-code",
    element: <ResetPassForm />,
    isProtected: false,
    isLanding: false,
  },
  {
    path: "/new-user/",
    element: <NewUserPage />,
    isProtected: false,
    isLanding: true,
  },
  {
    path: "/no-role",
    element: <NoRoleAssignedPage />,
    isProtected: false,
    isLanding: false,
  },

  // Dashboard pages (protected)
  {
    path: "/dashboard",
    element: <DashboardPage />,
    isProtected: true,
    isLanding: false,
  },

  {
    path: "/dashboard/ai",
    element: <AIEmployeePage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/ai-workspace",
    element: <AIWorkspace />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/calendars",
    element: <CalendarPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/people",
    element: <ContactPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/companies",
    element: <ContactPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/people/:id",
    element: <ContactDashboard />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/companies/:id",
    element: <ContactDashboard />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/tasks",
    element: <TaskPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/task/template",
    element: <TaskTemplatePage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/task/group-tasks",
    element: <GroupTaskTempPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/task/lists/:id",
    element: <TaskListDetailsPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/task/type",
    element: <TaskTypePage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/matter",
    element: <CasesPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/matter/:id",
    element: <CaseDashboard />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/matter/:client_ref/:id",
    element: <CaseDashboard />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/matter-template",
    element: <CaseTemplate />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/activities",
    element: <ActivitiesPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/bills",
    element: <BillingPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/bank_accounts",
    element: <AccountPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/bank_accounts/:id/:accountName/",
    element: <BankTransaction />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/documents",
    element: <DocumentPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/documents/folder/*",
    element: <DocumentPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/documents/templates",
    element: <DocumentTemplatePage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/documents/categories",
    element: <DocumentCategory />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/communications",
    element: <Communications />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/reports",
    element: <ReportPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/settings",
    element: <SettingPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/settings/*",
    element: <SettingPage />,
    isProtected: true,
    isLanding: false,
  },
  {
    path: "/dashboard/custom_fields",
    element: <CustomeFields />,
    isProtected: true,
    isLanding: false,
  },
];

// Create landing paths array from routes with isLanding: true
export const landingPaths = routes
  .filter((route) => route.isLanding === true)
  .map((route) => route.path);
